<template>
  <div class="ticket_way_container">
    <div class="container text-center color-ccc fs-30 empty-tip ">{{ $t('public.ticketTips') }}</div>
    <!-- <div class="container text-center color-ccc fs-30 empty-tip ">Please Follow "广州国际汽车展" WeChat Official Account To Ticketing. -->
 <!-- </div> -->
    <img src="@/assets/img/pubImg.png" alt=""/>
      <!-- <el-table
      :data="ticketList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="types" label="类型"></el-table-column>
      <el-table-column prop="fees" label="票价"></el-table-column>
      <el-table-column prop="dates" label="有效日期"></el-table-column>
      <el-table-column prop="tips" label="说明"></el-table-column>
    </el-table> -->
  </div>
</template>

<script>
export default {
    data(){
        return{
            ticketList:[
                {
                    types:"专业观众票",
                    fees:"100元",
                    dates:"12月31日-1月8日",
                    tips:"有效日期内任选一日进场参观，一次进场有效"
                },
                {
                    types:"普通观众票",
                    fees:"50元",
                    dates:"1月2日-1月8日",
                    tips:"有效日期内任选一日进场参观，一次进场有效"
                }
            ]
        }
    }
}
</script>

<style lang="scss">
.ticket_way_container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    >img{
        width: 40%;
        margin-top: 30px;
    }
    >div{
      line-height: 50px;
    }
}


@media screen and (max-width: 1000px) {
  .ticket_way_container {
    width: 100vw;
  }
}
</style>


// WEBPACK FOOTER //
// ticketWay.vue?10784b97